"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Alert2["default"];
  }
});
require("./Alert.scss");
var _Alert2 = _interopRequireDefault(require("react-bootstrap/lib/Alert"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Alert.js
// module id = 33
// module chunks = 25